import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppComponent } from './app.component';
import { ErrorPageComponent } from 'src/app/components/error-page/error-page.component';
import { RegisterComponent } from 'src/app/components/register/register.component';
import { BlackScreenComponent } from 'src/app/components/black-screen/black-screen.component';
import { RouterModule, Routes } from '@angular/router';
import {HttpClientModule, HTTP_INTERCEPTORS, HttpClient} from '@angular/common/http';
import { OauthLibModule } from 'oauth-lib';
import { SecurityService } from 'src/app/services/security-service/security.service';
import { UserStorageService } from 'src/app/services/user-storage-service/user-storage.service';
import { MaintenanceService } from 'src/app/services/maintenance-service/maintenance.service';
import { MaintenanceDaoService } from 'src/app/dao/maintenance-dao-service/maintenance-dao.service';
import { TurnsService } from 'src/app/services/turns-services/turns-service/turns.service';
import { TurnsDaoService } from 'src/app/dao/turns-dao-services/turns-dao-service/turns-dao.service';
import { CommunicationService } from 'src/app/services/communication-service/communication.service';
import { PreventManualUrlGuard } from 'src/app/guards/prevent-manual-url.guard';
import { OauthInterceptorService } from 'src/app/services/oauth-interceptor/oauth-interceptor.service';
import {AngularFittextModule} from 'angular-fittext';
import { environment } from 'src/environments/environment';
import { ServiceWorkerModule } from '@angular/service-worker';
import { AdminScreenComponent } from './components/admin-screen/admin-screen.component';
import { AdvanceDeskScreenComponent } from './components/advance-desk-screen/advance-desk-screen.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import { PendingTurnsScreenComponent } from './components/pending-turns-screen/pending-turns-screen.component';
import {DateUnixTransformerPipe} from './pipes/date-unix-transformer-pipe/date-unix-transformer.pipe';
import {TranslateLoader, TranslateModule} from '@ngx-translate/core';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import { ControlScreenComponent } from './components/control-screen/control-screen.component';
import { FormatTimePipe } from './pipes/format-time.pipe';
import {MaterialModule} from './material.module';
import {AddNotesDialogComponent} from "./components/add-notes-dialog/add-notes-dialog.component";


export function HttpLoaderFactory(http: HttpClient): TranslateHttpLoader {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

const routes: Routes = [
  { path: '', component: AppComponent },
  { path: 'register/:token', component: RegisterComponent, canActivate: [PreventManualUrlGuard] },
  { path: 'admin', component: AdminScreenComponent },
  { path: 'advanceDesk', component: AdvanceDeskScreenComponent },
  { path: 'control', component: ControlScreenComponent },
  { path: 'pendingTurns', component: PendingTurnsScreenComponent },
  { path: 'error', component: ErrorPageComponent, canActivate: [PreventManualUrlGuard] }
];

@NgModule({
  declarations: [
    AppComponent,
    ErrorPageComponent,
    RegisterComponent,
    BlackScreenComponent,
    AdminScreenComponent,
    AdvanceDeskScreenComponent,
    PendingTurnsScreenComponent,
    DateUnixTransformerPipe,
    ControlScreenComponent,
    FormatTimePipe,
    AddNotesDialogComponent
  ],
  imports: [
    BrowserModule,
    RouterModule.forRoot(routes, {useHash: true}),
    HttpClientModule,
    BrowserAnimationsModule,
    OauthLibModule,
    AngularFittextModule,
    ServiceWorkerModule.register('ngsw-worker.js', {enabled: environment.serviceWorker}),
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      },
      defaultLanguage: 'es_ES'
    })
  ],
  providers: [
    SecurityService,
    UserStorageService,
    MaintenanceService,
    MaintenanceDaoService,
    TurnsService,
    TurnsDaoService,
    CommunicationService,
    PreventManualUrlGuard,
    DateUnixTransformerPipe,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: OauthInterceptorService,
      multi: true
    }],
  bootstrap: [AppComponent],
  entryComponents: [
    AddNotesDialogComponent
  ]
})
export class AppModule { }
